/*
 * 接口统一集成模块
 */
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as dict from './moudules/dict'
import * as log from './moudules/log'
import * as sysOption from './moudules/sysOption'
import * as hello from './moudules/hello'

// 默认全部导出
export default {
  login,
  user,
  dept,
  role,
  menu,
  dict,
  log,
  sysOption,
  hello
}



// WEBPACK FOOTER //
// ./src/http/api.js